import { configureStore } from '@reduxjs/toolkit'
import user from './reducers/user';
import main from './reducers/main';
import dict from './reducers/dict';

const store = configureStore({
	reducer: {
		user,
		main,
		dict,
	},
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;